/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VehiclePhotoType = {
    Front: 'FRONT',
    Back: 'BACK',
    Left: 'LEFT',
    Right: 'RIGHT',
    Cargo: 'CARGO'
} as const;
export type VehiclePhotoType = typeof VehiclePhotoType[keyof typeof VehiclePhotoType];

